/*  */
import { FormattedMessage, MessageDescriptor, IntlShape } from "react-intl";


let ENTREGA_TYPE = -3
let DRIVER_TYPE = 2 // 司机
// import I18nAlias from "../locales/i18n-alias";

export const setCookie = (name: string, value: string, hours: number) => {
    let date = new Date()
    let ms = hours * 3600 * 1000
    date.setTime(date.getTime() + ms)
    document.cookie = name + '=' + value + '; PATH=/; expires=' + date.toUTCString()
}

export const getCookie = (name: string) => {
    let cookies = document.cookie
    let cookieMap: { [key: string]: string } = {}
    cookies && cookies.split('; ').map(item => {
        let t = item.split('=')
        cookieMap[t[0]] = t[1]
        return item
    })
    return cookieMap[name]
}

// 时间转时间戳
export const getDateTime = function (data :string | undefined = '') {
    return new Date(data).getTime()
}

export const DateFormat = (date: Date, fmt = "yyyy-MM-dd hh:mm:ss") => {
    const o: { [key: string]: number } = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length === 1
                    ? `${o[k]}`
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
    }
    return fmt;
};

export const isObject = (value: any) => {
    return Object.prototype.toString.call(value) === "[object Object]"
}

export const i18nReplace = (obj: { [key: string]: any }) => {
    let keyArr = Object.keys(obj);
    let result: typeof obj = {};
    keyArr &&
        keyArr.forEach((item) => {
            // 获取数据
            let val = obj[item];
            // 兼容老翻译文案对象格式 2021.3.17 yanshenshen
            if (isObject(val)) {
                return i18nReplace(val)
            }
            // 双括号{{}} 替换为<<>>
            let s1 = val.replace(/{{/g, "<<").replace(/}}/g, ">>");
            // // 单括号{} 替换为 [{}] 作为颜色和文字替换工具
            let s2 = s1.replace(/\{/g, "[").replace(/\}/g, "]");
            // // <<>>  => {}
            let s3 = s2.replace(/<</g, "{").replace(/>>/g, "}");
            result[item] = s3;
        });
    return result;
};

/**
 * 表单去除字符串的头尾空格
 * obj Object 表单对象
 * arr Array 需要去除头尾空格obj的key值
 */
interface trimable<T> {
    trim(): T;
}
export function fromTrim<T extends trimable<T>>(obj: { [key: string]: T }, arr: string[]) {
    let newObj = { ...obj }
    arr.map(re => {
        if (newObj[re] && newObj[re]) {
            newObj[re] = newObj[re].trim()
        }
        return re
    })
    return newObj;
};
export const getUrlParam = (name: string) => {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    const r = window.location.search.substr(1).match(reg)
    if (r != null) return r[2]
    return null
}

export const setArrToObj = (pairs: string[]) => {
    const args: { [key: string]: string } = {};
    for (let i = 0; i < pairs.length; i += 1) {
        const pos = pairs[i].indexOf('=');
        if (pos !== -1) {
            const argname = pairs[i].substring(0, pos);
            let value = pairs[i].substring(pos + 1);
            value = decodeURIComponent(value);
            args[argname] = value;
        }
    }
    return args;
}

export const parseQueryString = (url: string | undefined) => {
    let urlKey = url?.split("?")[1]
    let objKeyValue = {}
    if (urlKey) {
        let urlObj = urlKey.split("&")
        // 以对象形式存放
        urlObj.forEach((re) => {
            objKeyValue[re.split("=")[0]] = decodeURIComponent(re.split("=")[1])
        })
    }
    return objKeyValue
}

export const getUrlHashArgs = () => { // 获取hash参数，并输出对象
    let hashArr = window.location.hash.split('?')
    if (hashArr.length === 1) {
        return {}
    }
    const pairs = hashArr[1].split('&');
    return setArrToObj(pairs)
}

export const getUrlSearchArgs = () => {// 获取search参数，并输出对象
    const pairs = window.location.search.substr(1).split('&');
    return setArrToObj(pairs)
}

export const getUrlArgs = () => {// 获取url所有参数包括hash和search，并输出对象
    const args = { ...getUrlSearchArgs(), ...getUrlHashArgs() };
    return args
}

export const setUrlSearch = (obj?: Record<string, any>) => {// 设置url的search，并输出字符串
    if (!obj) {
        return ''
    }
    let arr = Object.keys(obj)
    let search = ''
    let num = 0
    arr.forEach((re, idx) => {
        if (obj[re] === "" || obj[re] === 'undefined' || obj[re] === undefined) {
            return
        }
        if (num === 0) {
            search += `?${re}=${obj[re]}`
        } else {
            search += `&${re}=${obj[re]}`
        }
        num++
    })
    return search
}


// 拼接url
export const urlAddQuery = (origin: string | undefined, obj?: Record<string, any>) => {
    let search = ''
    if (origin?.includes("?")) {
        let urlSearch = setUrlSearch(obj)
        search = '&' + urlSearch.substr(1, urlSearch.length)
    } else {
        search = setUrlSearch(obj)
    }
    return origin + search
    // return setUrlSearch({...parseQueryString(origin), ...obj})
}

// 拼接url
export const splitUrlSearch = (origin: string | undefined, obj?: Record<string, any>) => {
    return setUrlSearch({ ...parseQueryString(origin), ...obj })
}

export const onbeforeunload = (text: any) => {
    window.addEventListener("beforeunload", function (event) {
        event.preventDefault();
        event.returnValue = text
    });
}

type Fn = (...args: any) => any
// 防抖
export function debounce<T extends Fn = Fn>(fn: T, delay: number) {
    let timer: ReturnType<typeof setTimeout> | null = null
    return function (this: any, ...args: Parameters<T>) {

        timer && clearTimeout(timer)
        const context = this
        timer = setTimeout(() => {
            fn.apply(context, args)
        }, delay)
    }
}

// 节流
export function throttle<T extends Fn = Fn>(fn: T, delay: number){
    let timer: number = 0;
    return function (this: any, ...args: Parameters<T>) {
        let context = this;
        let now = Date.now();
        if (now - timer > delay) {
            fn.apply(context, args);
            timer = now;
        }
    };
};

// 手机号加密
export const encryptPhoneFun = (phone: string) => {
    if (phone) {
        let star = ''
        for (let i = 0; i < phone.length - 6; i++) {
            star = star + '*'
        }
        return phone.slice(0, 3) + star + phone.slice(phone.length - 3, phone.length)
    }
}

// 邮箱加密
export const encryptEmailFun = (email: string) => {
    if (email) {
        let com = email.slice(email.indexOf('@') - 1, email.length)
        let star = ''
        for (let i = 0; i < email.length - com.length - 1; i++) {
            star = star + '*'
        }
        return email.slice(0, 1) + star + com
    }
}

// 正则验证规则
/*
    reg 正则表达式
    val 验证的值
*/
export const regsTest = (reg: RegExp, val: string) => {
    return reg.test(val)
}

export const regsRule = {
    phone: /^[+,0-9][0-9]{7,}$/,
    amount: /^\d+(\.\d{1,2})?$/
}

export const regRuleTest = {
    phone: (val: string) => {
        return regsTest(regsRule.phone, val)
    },
    amount: (val: string) => {
        return regsTest(regsRule.amount, val)
    },
    isnull: (val: string) => {
        return val === ""
    }
}

export const CANONICAL_COUNTRY_CODE = getUrlArgs().canonical_country_code || getCookie('canonical_country_code') || 'BR'
export const ORGANIZATION_ID = getUrlArgs().organization_id || getCookie('organization_id') || '1'
export const UTC_OFFSET = getUrlArgs().utc_offset || getCookie('utc_offset') || '-180'
export const LANG = getUrlArgs().lang || getCookie('lang') || 'zh-CN'
export const USER_NAME = getUrlArgs().user_name || getCookie('user_name')
export const USER_ID = getUrlArgs().userid || getCookie('userid') 
export const COUNTRU_TEL_Id = getCookie('countryTelId') || '55'
export const JAVALANG = LANG?.toLowerCase().replace(/-/g, "_")

// 重设翻译id
const setI18nId = (id: string) => {
    // let langLowerCase = LANG.toLowerCase().replace(/-/g, "_") // 小写字母的转换 ，i18n-alias 命名规范是字母全部小写,并且以下划线连接
    // let getAliasId = (I18nAlias as Record<string, any>)[langLowerCase][id] // 判断 i18n-alias 文件中是否包含相关联文案
    // return getAliasId ? getAliasId : id
    return id
}

export function $t<T extends MessageDescriptor["defaultMessage"]>(id: string, defaultMsg?: T, values?: any) {
    let comp = (
        <FormattedMessage id={setI18nId(id)} defaultMessage={defaultMsg} values={values} />
    );
    return comp;
};

export function $tmsg(intl: IntlShape, id: string) {
    return intl.formatMessage({ id: setI18nId(id) });
};

// 接口组装数据  in  ：obj，筛选 out ： array，返回 obj
export const parmRebuild = (inParm: Record<string, any>, outParm: Array<string>) => {
    let newObj = {}
    outParm.map((re) => newObj[re] = inParm[re])
    return newObj
}

let magellan_url_path = '//magellan.didiglobal.com'
if (window.location.origin.includes('-de.')) {
    magellan_url_path = '//magellan-de.didiglobal.com'
}
export const MAGELLAN_URL_PATH = magellan_url_path

export const replaceI18nVariable = (template: any, values: string[]) => {
    if (Array.isArray(values)) {
        values.forEach(item => {
            console.log(item);
            template = template.replace(/\{\{[^}]*\}\}/, () => {
                return item;
            })
        })
    }
    return template;
}

let set_workbench_type =() =>{
    let { href } = window.location
    let workbench_type = 'offline' // 异步
    if(href.includes('fe/im')){
      workbench_type = 'livechat' // im
    } else if(href.includes('ark/genesys')){
      workbench_type = 'phone' // 电话
    } 
    return workbench_type
}

// 设置OMG埋点信息
export const SET_WORKBENCH_TYPE =()=>{
    let type = set_workbench_type()
    if(getUrlArgs().source === 'im'){
        type = 'livechat'
    }
    if(getUrlArgs().source === 'phone'){
        type = 'phone'
    }
    return type
}

// 渠道
export const WORKBENCH_TYPE =  SET_WORKBENCH_TYPE()

export const OMEGEATTR = {
    lang: LANG,
    canonical_country_code: CANONICAL_COUNTRY_CODE,
    user_id: USER_ID,
    user_name: USER_NAME,
    userid:USER_ID,
    organization_id: ORGANIZATION_ID,
    utc_offset: UTC_OFFSET,
    workbench_version : '2.0',
    workbench_type : WORKBENCH_TYPE,
}

// 获取UTC时间
export const timeInitUTC = function (data?: any) {
    let dd = new Date()
    if (typeof data == 'number') {
        dd = new Date(data)
    }
    let y = dd.getUTCFullYear()
    let m = (dd.getUTCMonth() + 1) < 10 ? '0' + (dd.getUTCMonth() + 1) : (dd.getUTCMonth() + 1)
    let d = dd.getUTCDate() < 10 ? '0' + dd.getUTCDate() : dd.getUTCDate()
    //    获取当前时间，不足10补0
    let h = dd.getUTCHours() < 10 ? '0' + dd.getUTCHours() : dd.getUTCHours()
    let mm = dd.getUTCMinutes() < 10 ? '0' + dd.getUTCMinutes() : dd.getUTCMinutes()
    let s = dd.getUTCSeconds() < 10 ? '0' + dd.getUTCSeconds() : dd.getUTCSeconds()
    return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s
    //    return y + '-' + m + '-' + d
}

// 获取UTC时间戳
export const getUTCtime = function () {
    return new Date(timeInitUTC()).getTime()
}


export function IsNaN(value:any) {return typeof value === 'number' && !isNaN(value)}
/**
 * 验证输入
 * value 数值 必填
 * length 小数点保留位数 选填
 */
export function checkAmountERR(value:string | number,length:number) {
    // 输入非数字
    if(!IsNaN(Number(value))){
        return true
    }
    let AmountArr = String(value).split('.')
    if(AmountArr[1] && AmountArr[1].length > length){
        return true
    }else{
        return false
    }
}

// 金额互转
/**
 * 元转分
 * value 数值 必填
 * length 小数点保留位数 选填
 */
export const DtransC = function (value:string | number,length:number = 2) {
    return parseFloat(( Number(value) * 100).toFixed(length))
}

export const sessionId = getUrlArgs()?.imSessionId;
export const im = getUrlArgs().source === 'im';
export const uid = getUrlArgs().uid;
export const seatId = USER_NAME;


/* 分析司乘订页面来源 版本  2.0  || 1.0  workbench_version */
export const SET_PARENT_WORKBENCH_VERSION = function () {
    let version = '2.0'
    try {
        if(window.parent){
            if(window.parent.parent){
                let { href } = window.parent.parent.location
                if((href.includes('#/ark/ticket-lists') || href.includes('#/ark/work-bench-list') || href.includes('#/ark/ticket-create/ticket-new') || href.includes('#/ark/ticket-detail')) && href.includes('/fe/ark_fe')){
                    version = '1.0'
                }
            }
        }
    } catch (error) {}
    return version
}


/* 回复文案内容调整  */
export const DANGEROUSLY_HTML_CONTENT = (html ?: any)=>{
    if(!html){
        return ''
    }
    let myHtml = html
    try {
        let reg = /<!--(.|[\r\n])*?-->/g
        myHtml = html.replace(reg, "")
        // myHtml = html.replace(/div,|h2,|, div/g, "")
    } catch (error) {
        
    }
    return myHtml
}

// 筛选业务类型，新增闪送商家业务线，业务类型需要单独
export const  FILTER_BUSINESS_LIST = (requesterType?:string | number, businessTypeList ?: any)=>{
    let setBusinessTypeList =[]
    if(requesterType === DRIVER_TYPE  || !requesterType){
        return businessTypeList
    }
    if(requesterType === ENTREGA_TYPE){
        setBusinessTypeList = businessTypeList.filter((re: { isFlag: number; }) => re.isFlag === ENTREGA_TYPE );
    }else{
        setBusinessTypeList = businessTypeList.filter((re: { isFlag: number; }) => re.isFlag !== ENTREGA_TYPE);
    }
    return setBusinessTypeList
}
// 是否是闪送业务线
export const  IS_STORE_BUSINESS =  (requesterType:string | number,businessType :string | number , businessTypeList : any)=>{
    if(requesterType === ENTREGA_TYPE){
        return true
    }
    if(requesterType === DRIVER_TYPE ){
        let setBusinessTypeList =[]
        setBusinessTypeList = businessTypeList.filter((re: { isFlag: number; value: string | number; }) => re.isFlag === ENTREGA_TYPE && Number(businessType) === Number(re.value) );
        console.log("123334",setBusinessTypeList)
        if(setBusinessTypeList.length > 0){
            return true
        }else{
            return false
        }
    }
}
